// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1j2S0","footer":"ModalInfo_footer__2DcV9"};